import Feature from "ol/Feature";
import Geometry from "ol/geom/Geometry";

import ChangelogMode from 'lib/enums/changelogmode';
import Author from 'lib/enums/author';

import { useState, useEffect } from "react";
import { Popup, PopupProps } from "lib/classes/popup";
import { getLocaleString } from "lib/localization/vendor";
import { assetURL } from "lib/utilities/asset";

import 'styles/css/ChangelogPopup.scss';

const ChangelogPopup = new Popup({
	title: function() {
		return getLocaleString('changelog');
	},
	style: {
		maxWidth: 550
	},
	closeable: true,
	render: function() {
		const feature:Feature<Geometry> = this.get('feature');
			
		const drawChangelog = () => {
			const changelog:any[] = JSON.parse(feature.get('changelog') || '[]');
			const rows:any[] = [];
			
			changelog.forEach(entry => {
				
				const changelogMode:ChangelogMode = entry.m;
				const author:Author = entry.a;
				
				rows.push(
					<div className='changelog__entry' key={rows.length}>
						{getLocaleString('cl-row-str', [
							getLocaleString(String(ChangelogMode[changelogMode]).toLowerCase()),
							getLocaleString(String(Author[author]).toLowerCase()),
							new Date(entry.t).toString()
						])}
					</div>
				)
			});
			
			if(rows.length < 1) {
				return (
					<p>{getLocaleString('no-entries')}</p>
				)
			}
			
			return rows;
		}
			
		if(!feature) {
			return (
				<p>{getLocaleString('no-feature')}</p>
			)
		}
		
		return (
			<>
				{drawChangelog()}
			</>
		)
	}
});

export default ChangelogPopup;